import {EEntityType} from 'shared/constants/entities';
import {performRequest, TRequestPromise} from 'shared/utils';
import {entityTypeForRequest} from 'shared/utils/entity-type-for-request';

import {IEntityMeta} from './metadata-types';

export const fetchEntityMetadata = <T extends IEntityMeta>(
    entityName: string,
    entityType: EEntityType,
    taxPeriodId?: number | null,
): TRequestPromise<T> => performRequest({
        url: `meta/${entityName}/${entityTypeForRequest(entityType)}`,
        params: {
            ...(taxPeriodId && entityType === EEntityType.TABLE && {taxPeriodId}),
        },
        method: 'GET',
    });

export const getAllMetadata = <T extends IEntityMeta[]>(): TRequestPromise<T> => performRequest({
    url: 'meta/table',
    method: 'GET',
});

export const fetchAllMetadata = () => performRequest({
    url: 'meta',
    method: 'GET',
});
